import React from 'react';
import './css/Main.css';

export default function MainInspection() {
  return (
    <section>
      <div className="inspection">
        <h2 className="section-title">
          ENDING INFORMATION INEQUALITY IN THE USED CAR MARKET
        </h2>
        <center>
          Every vehicle listed on P2PAUTO must pass our inspection standards.
        </center>
        <div className="inspection-list">
          <div className="inspection-item">✓ Engine Condition</div>
          <div className="inspection-item">✓ Transmission</div>
          <div className="inspection-item">✓ Chassis & Structural Integrity</div>
          <div className="inspection-item">✓ Accident History</div>
          <div className="inspection-item">✓ Electrical Systems</div>
          <div className="inspection-item">✓ Exterior & Interior Condition</div>
        </div>
      </div>
      <div className="inspection-mobile">
        <h2 className="section-title">
          ENDING INFORMATION INEQUALITY
        </h2>
        <p>
          <b>Our role isn't to tell you what to buy.</b><br/><br/>  

          We provide clear, objective information so you understand the vehicle's structural condition before making your decision. Every buyer has different expectations, and every inspected vehicle deserves transparent disclosure.
        </p>
      </div>
    </section>
  )
}